<template>
	<section ref="sectionRef"
			 class="flex-module container-fluid flexible-sticky-title-text">
		<div class="row">
			<div class="col-xs-12 col-md-5">
				<div ref="stickyWrapperRef"
					 class="sticky-wrapper">
					<h2 v-if="item.title"
						class="sticky-title">
						{{ item.title }}
					</h2>
					<button :id="'accordion-label-' + uid"
							class="show-more-button"
							role="button"
							:aria-controls="'accordion-body-' + uid"
							:aria-expanded="textExpanded ? 'true' : 'false'"
							data-cursor-hover
							@click="toggleOpenStatus">
						<span v-if="!textExpanded">Tell me more
							<Icon name="tdesign:plus" />
						</span>
						<span v-else>Actually, shhh
							<Icon name="tdesign:minus" />
						</span>
					</button>
				</div>
			</div>

			<div class="col-xs-12 col-sm-8 col-sm-offset-4 col-md-offset-0 col-md-7 col-lg-6 col-lg-offset-1 col-xxl-5">
				<div :id="'accordion-label-' + uid"
					 ref="bodyTextRef"
					 v-interpolation
					 :aria-labelledby="'accordion-label-' + uid"
					 class="richtext body-text-wrapper"
					 v-html="item.body" />
			</div>
		</div>
	</section>
</template>

<script setup>
const props = defineProps({
	data: {
		type: Object,
		required: true
	},
})

const { gsap, ScrollTrigger } = useGsap()
const { $bus } = useNuxtApp()
const mediaQuery = gsap.matchMedia()

const sectionRef = ref(null)
const stickyWrapperRef = ref(null)
const bodyTextRef = ref(null)

const uid = useId()
const textExpanded = ref(false)
const stickyHeight = ref(0)
const triggers = {}
let tl

const item = computed(() => props.data?.item)

function toggleOpenStatus() {
	textExpanded.value = !textExpanded.value

	tl.reversed() ? play() : reverse()
}

function play() {
	triggers.stickyTitleRef
	tl.play()
}

function reverse() {
	tl.reverse()
	cleanUp()
}

function animHiddenText() {
	tl = gsap.timeline({ reversed: true })
		.fromTo(bodyTextRef.value, {
			height: 0,
		}, {
			height: bodyTextRef.value.scrollHeight,
			duration: 0.25,
			onComplete: () => {
				// animStickyTitle()
			}
		})
}

// function animStickyTitle() {
// 	stickyHeight.value = stickyWrapperRef.value.offsetHeight

// 	mediaQuery.add('(min-width: 768px)', () => {
// 		triggers.stickyTitle = ScrollTrigger.create({
// 			id: 'stickyTitle',
// 			trigger: sectionRef.value,
// 			start: 'top 20%',
// 			endTrigger: bodyTextRef.value,
// 			end: () => `bottom 20%+=${stickyHeight.value}`,
// 			pin: stickyWrapperRef.value,
// 			pinSpacing: false,
// 			invalidateOnRefresh: true
// 		})

// 		$bus.$emit('scrolltrigger-refresh')

// 		return () => {
// 			cleanUp()
// 		}
// 	})
// }

function cleanUp() {
	killTriggers(triggers)
}

onMounted(() => {
	stickyHeight.value = stickyWrapperRef.value.offsetHeight

	animHiddenText()
})

onBeforeUnmount(() => {
	cleanUp()
})
</script>

<style lang="scss" scoped>
h2 {
	@include textH2;
	margin-top: 0;
	word-break: normal;
	text-transform: uppercase;
	margin-bottom: 0;
}

.body-text-wrapper {
	// max-height: 0px;
	height: 0;
	overflow: hidden;
	transition: max-height 0.5s ease-in-out;
}

:deep(.richtext) {
	h2 {
		@include textH5;
		// margin-top: 0;
		word-break: normal;

		>p {
			margin-top: 0;
		}
	}
}

.show-more-button {
	@include nobutton;
	@include textBody;
}
</style>
